module.exports = "/_assets/images/theming/hex-characters/corval-hex-paper-discussion.png";